<template>
  <div id="menu-overlay" v-if="isOpen">
    <div class="menu-overlay-inner">
      <div class="close-overlay-box">
        <div class="close-overlay"><Button @click="close">X</Button></div>
      </div>
      <h2 class="text-center">Menu</h2>
      <div class="four-key-menus text-center speedee-bold">
        <div class="four-menu">
          <div class="menu-item" v-for="(icon, index) in icons" :key="index">
            <a
              :href="getMenuLink(index, icon.name)
              "
            >
              <img
                :src="icon.menu_icon"
                class="breakfast-menu"
                style="width: auto; height: 90px"
              />
              <span>
                {{ icon.name }}
              </span>
            </a>
          </div>
        </div>
      </div>
      <div class="food-menu-overlay">
        <ul class="menu">
          <li
            class="expanded"
            v-for="(category, index) in categories"
            :key="index"
          >
            <span title="" class="nolink" tabindex="0">{{
              category.name
            }}</span>
            <div>
              <ul
                class="menu"
                v-for="(list, indexOne) in categories[index].lists"
                :key="indexOne"
              >
                <li class="leaf">
                  <a :href="getListIndex(index, indexOne, list.name)">{{ list.name }}</a>
                </li>
              </ul>
            </div>
           
          </li>
        </ul>
      </div>
      <div class="pickup-wrap">
        <div class="mc-pickup">
          <img src="@/assets/images/hamburger-menu/bag.svg" />
          <a href="/contact">Pick-up</a>
        </div>
        <div class="mc-delivery">
          <img src="@/assets/images/hamburger-menu/mcdelivery.svg" />
          <a href="/contact">McDelivery</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { category } from "@/data/ecommerce/filter";
import axios from "axios";
export default {
  props: {
    isOpen: {
      type: Boolean, // Whether the menu should be open or not
      required: true,
    },
  },

  data() {
    return {
      categories: [],
      icons: [],
    };
  },

  mounted() {
    this.loadCategories();
    this.loadIcons();
  },

  methods: {
    close() {
      this.$emit("close-overlay");
    },

    loadCategories() {
      axios.get("/products/categories?type=2").then((response) => {
        let categories = response.data.data;

        categories.forEach(category => {
          if(category.type == 2) {
            this.categories.push(category)
          }
        });
      });
    },

    loadIcons() {
      axios.get("/products/lists/icons").then((response) => {
        this.icons = response.data.data.lists;
      });
    },

    //increment indexOne based on the total number of lists in each category
    getListIndex(categoryIndex, listIndex, name) {
      let indexSum = 0;
      for (let i = 0; i < categoryIndex; i++) {
        indexSum += this.categories[i].lists.length;
      }
      return `/menu?val=${indexSum + listIndex}&name=${name}`;
    },

    getMenuLink(menuValue, name) {
      // Build the route link with the "propValue" prop
      return `/menu?val=${menuValue}&name=${name}`;
    },
  },
};
</script>


<style>
.burger-menu-open #menu-overlay {
  display: inherit;
  background-color: #fff;
  position: relative;
}

.food-menu-overlay {
  margin-bottom: 5rem;
  position: initial;
}

.food-menu-overlay:before {
  content: "";
  background-image: url("@/assets/images/hamburger-menu/menu-oval.png");
  background-repeat: no-repeat;
  background-size: 140%;
  background-position: bottom center;
  position: absolute;
  left: 0;
  right: 0;
  width: 100%;
  top: 0;
  bottom: 300px;
  z-index: -2;
}

ul.menu {
  border: none;
  list-style: none;
  text-align: left;
  flex-wrap: wrap;
}

.food-menu-overlay > ul.menu > li > span,
.food-menu-overlay > ul.menu > li ul {
  display: block;
}

.food-menu-overlay > ul.menu > li > span {
  font-size: 50px;
  font-size: 3.125rem;
  line-height: 45px;
  line-height: 2.813rem;
  width: 210px;
  text-align: right;
  position: absolute;
  top: 5.4rem;
  left: -2.8rem;
  -webkit-transform: rotate(-90deg);
  -moz-transform: rotate(-90deg);
  -ms-transform: rotate(-90deg);
  -o-transform: rotate(-90deg);
  transform: rotate(-90deg);
  letter-spacing: -0.875px;
  font-weight: 600;
}

.food-menu-overlay ul.menu {
  width: 100%;
  margin: 0 auto;
  padding: 0;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}

.food-menu-overlay ul li {
  display: block;
}

.food-menu-overlay li a {
  font-size: 20px;
  font-size: 1.25rem;
  line-height: 35px;
  line-height: 2.188rem;
  letter-spacing: -0.5px;
  white-space: nowrap;
  color: black;
  text-decoration: none;
}

.food-menu-overlay > ul.menu > li.first {
  width: 42%;
  display: flex;
  justify-content: space-around;
}

.food-menu-overlay > ul.menu > li {
  position: relative;
  margin-left: 0;
  padding-left: 6.3rem;
}

.food-menu-overlay > ul.menu > li {
  padding-right: 0;
}

#menu-overlay h2 {
  font-size: 70px;
  font-size: 4.375rem;
  margin-top: -1.9rem;
  margin-bottom: 1.9rem;
  letter-spacing: -1.75px;
  font-weight: 600;
}

#menu-overlay {
  position: fixed;
  background: #fff;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10000;
  overflow-y: auto;
}

.close-overlay-box {
  margin-top: 30px;
  text-align: right;
}

.close-overlay {
  width: 50px;
  height: 50px;
  display: inline-block;
  position: relative;
  cursor: pointer;
  transition: 0.3s all;
}

.four-menu {
  display: flex;
  justify-content: space-between;
  gap: 15px;
}



@media screen and (max-width: 574px) {
  .four-menu {
    display: flex;
    justify-content: center;
    gap: 15px;
    flex-wrap: wrap;
  }

  .food-menu-overlay ul.menu {
    width: 100%;
    margin: 0 auto;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 30px;
  }
}

.four-key-menus .menu-item {
  font-size: 15px;
  font-size: 0.938rem;
  position: relative;
  width: 250px;
  min-height: 154px;
  margin-bottom: 4%;
  background-color: #fff;
  display: block;
}

.four-key-menus .menu-item span:before {
  content: "";
  background-repeat: no-repeat;
  background-position: center;
  display: block;
  margin-top: 15px;
}

.four-key-menus .menu-item:before {
  content: "";
  position: absolute;
  left: 10px;
  right: 10px;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.1);
  box-shadow: 0px 10px 25px 5px rgba(0, 0, 0, 0.06);
  z-index: -1;
}

.menu-overlay-inner h2:before {
  content: "";
  background-color: #ffbc0d;
  position: absolute;
  top: 43px;
  left: -20px;
  right: -20px;
  height: 100px;
  z-index: -1;
  -webkit-transform: matrix(1, 0.034, 0.035, -1, 0, 0);
  -moz-transform: matrix(1, 0.034, 0.035, -1, 0, 0);
  -ms-transform: matrix(1, 0.034, 0.035, -1, 0, 0);
  -o-transform: matrix(1, 0.034, 0.035, -1, 0, 0);
  transform: matrix(1, 0.034, 0.035, -1, 0, 0);
}

.breakfast-menu {
  padding-top: 10px;
}

.menu-item a {
  text-decoration: none;
}

#header-navigation-overlay {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  transition: 0.1s all;
  width: 0;
  height: 0;
}

.menu-overlay-inner {
  max-width: 1170px;
  margin: 0 auto;
}

.close-overlay-box,
#menu-overlay h2 {
  position: relative;
}

.close-overlay-box {
  margin-top: 30px;
  text-align: right;
}

#menu-overlay h2,
.food-menu-overlay,
.menu-item a {
  color: #2d2d2d;
}

@media only screen and (min-width: 1500px) {
  .four-key-menus {
    margin-bottom: 4.8%;
  }
}

.four-key-menus {
  max-width: 855px;
  margin: 0 auto 2.8%;
}

.burger-menu-open .pickup-wrap {

  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  padding: 20px 0;
  width: 100%;
  margin: 0;
}

.pickup-wrap {
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 10px;
  padding-top: 150px;
}

.mc-delivery {
  padding-left: 14px;
}

.mc-pickup a {
  position: relative;
  font-size: 1.8vh;
  line-height: 1.5;
  padding-left: 14px;
  text-decoration: none;
  color: black;
}

.mc-delivery a {
  position: relative;
  font-size: 1.8vh;
  line-height: 1.5;
  padding-left: 14px;
  background-size: 35%;
  text-decoration: none;
  color: black;
}

.mc-pickup,
.mc-delivery {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: auto;
  line-height: 48px;
  margin: 30px 0;
}

.mc-pickup img,
.mc-delivery img {
  width: 50px;
}

@media screen and (max-width: 768px) {
  
  .food-menu-overlay > ul.menu > li > span {
    font-size: 28px !important; /* Smaller than desktop but still prominent */
    font-size: 1.75rem !important;
    line-height: 25px !important;
    width: 120px !important; /* Smaller width for mobile */
    text-align: right !important;
    position: absolute !important;
    top: 0 !important; /* Adjust vertical position */
    left: 1rem !important; /* Adjust horizontal position */
    -webkit-transform: rotate(-90deg) !important;
    -moz-transform: rotate(-90deg) !important;
    -ms-transform: rotate(-90deg) !important;
    -o-transform: rotate(-90deg) !important;
    transform: rotate(-90deg) !important;
    letter-spacing: -0.5px !important;
    font-weight: 600;
  }

  .food-menu-overlay > ul.menu > li > div {
    margin-left: 30px;
  }
  
  .food-menu-overlay > ul.menu > li {
    padding-left: 3rem !important; 
    margin-bottom: 25px;
    min-height: 80px; 
  }
  
  .food-menu-overlay > ul.menu > li ul {
    display: flex !important;
    flex-direction: column !important;
    gap: 8px;
    margin-top: 5px;
    padding-left: 0;
    left: 1rem;
  }
  
  /* Improve menu item links spacing and readability */
  .food-menu-overlay li a {
    font-size: 16px !important;
    font-size: 1rem !important;
    line-height: 1.3 !important;
    padding: 5px 0;
    display: absolute;
    right: 2rem;
  }
  
  /* Adjust the background oval for mobile */
  .food-menu-overlay:before {
    background-size: 200% !important;
    bottom: 200px !important;
  }
  
  /* Stack the pickup/delivery section properly */
  .pickup-wrap {
    position: static !important;
    padding-top: 30px !important;
    gap: 20px !important;
  }
  
  /* Make four-menu items more mobile-friendly */
  .four-key-menus .menu-item {
    width: 120px !important;
    min-height: 120px !important;
    font-size: 12px !important;
  }
  
  .four-key-menus .menu-item img {
    height: 60px !important;
  }
}

/* Additional fix for very small screens */
@media screen and (max-width: 480px) {
  .food-menu-overlay > ul.menu > li {
    padding-left: 2.5rem !important;
  }
  
  .food-menu-overlay > ul.menu > li > span {
    font-size: 24px !important;
    font-size: 1.5rem !important;
    width: 100px !important;
    left: -0.5rem !important;
    top: 2.8rem !important;
  }
  
  .four-menu {
    gap: 10px !important;
  }
  
  .four-key-menus .menu-item {
    width: 100px !important;
    min-height: 100px !important;
    font-size: 11px !important;
  }
  
  #menu-overlay h2 {
    font-size: 40px !important;
    font-size: 2.5rem !important;
  }
}
</style>